import { DeepMap, FieldError, Ref } from 'react-hook-form'

type FlattenedErrors = {
  field: string
  message: string,
  ref: Ref | undefined
}
function getRecursiveErrors<T> (errors: DeepMap<T, FieldError>) {
  const output: FlattenedErrors[] = []

  for (const [key, value] of Object.entries<any>(errors)) {
    const { ...others } = value
    if (value.message) {
      output.push({
        field: key,
        message: value.message,
        ref: value.ref
      })
    }

    if (!['message', 'ref', 'type', 'types'].includes(key)) {
      output.push(...getRecursiveErrors(others))
    }
  }

  return output
}

export function useHookFormErrors<T> (errors: DeepMap<T, FieldError>) {
  const output = getRecursiveErrors(errors)

  return output
}
